(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SupplierCouponCustom', SupplierCouponCustom);

    SupplierCouponCustom.$inject = ['$resource'];

    function SupplierCouponCustom($resource) {


        // var getSupplierCouponByType=function(subscriptionType)
        // {
        //
        //     var resourceUrl='api/get-subscription-package-by-type?subscriptionType='+subscriptionType;
        //     return $resource(resourceUrl, {}, {
        //         'query': { method: 'GET', isArray: true}
        //         }
        //
        //     );
        // };
        // var getSupplierCouponByPTypeAndSType=function(packageType,subscriptionType)
        // {
        //
        //     var resourceUrl='api/get-package-by-ptype-and-stype?subscriptionType='+subscriptionType+'&packageType='+packageType;
        //     return $resource(resourceUrl, {}, {
        //             'query': { method: 'GET', isArray: true}
        //         }
        //
        //     );
        // };


        return {
            // getSupplierCouponByType:getSupplierCouponByType,
            // getSupplierCouponByPTypeAndSType:getSupplierCouponByPTypeAndSType
        };
    }
})();
